// Phuket-specific service coverage data
// Distinct from Bangkok dataset to avoid duplicate content

export const PHUKET_DISTRICTS = [
  "อำเภอเมืองภูเก็ต", "อำเภอกะทู้", "อำเภอถลาง",
];

export const PHUKET_SUBDISTRICTS = [
  // เมืองภูเก็ต
  "ตลาดใหญ่", "ตลาดเหนือ", "เกาะแก้ว", "รัษฎา", "วิชิต", "ฉลอง", "ราไวย์", "กะรน",
  // กะทู้
  "กะทู้", "ป่าตอง", "กมลา",
  // ถลาง
  "เชิงทะเล", "เทพกระษัตรี", "ศรีสุนทร", "ไม้ขาว", "สาคู", "ป่าคลอก",
];

export const PHUKET_TOURIST_ZONES = [
  "ป่าตอง (Patong)", "กะตะ (Kata)", "กะรน (Karon)", "ราไวย์ (Rawai)", "กมลา (Kamala)",
  "สุรินทร์ (Surin)", "บางเทา (Bang Tao)", "ลากูน่า (Laguna)", "ในยาง (Nai Yang)",
  "ไม้ขาว (Mai Khao)", "เชิงทะเล (Cherngtalay)", "เมืองเก่าภูเก็ต (Old Town)",
];

export const PHUKET_MARINAS = [
  "อ่าวฉลอง (Chalong Bay)", "ท่าเทียบเรือรัษฎา (Rassada Pier)", "อ่าวปอ (Ao Por)",
  "Royal Phuket Marina", "Boat Lagoon Marina", "Yacht Haven Marina",
];

export const PHUKET_BUSINESS_HUBS = [
  "ถนนเฉลิมพระเกียรติ ร.๙", "เมืองเก่าภูเก็ต (Old Town)",
  "Central Phuket Festival", "Central Phuket Floresta", "Jungceylon ป่าตอง",
  "สนามบินภูเก็ต (HKT)", "Phuket FantaSea", "Boat Avenue เชิงทะเล",
];

export const PHUKET_INTL_HOSPITALS = [
  "โรงพยาบาลกรุงเทพภูเก็ต", "โรงพยาบาลสิริโรจน์", "โรงพยาบาลมิชชั่นภูเก็ต",
  "โรงพยาบาลวชิระภูเก็ต", "โรงพยาบาลดิบุ๊ค", "Phuket International Hospital",
];

export const PHUKET_GOV_OFFICES = [
  "ศาลากลางจังหวัดภูเก็ต", "ที่ว่าการอำเภอเมืองภูเก็ต", "ที่ว่าการอำเภอกะทู้",
  "ที่ว่าการอำเภอถลาง", "ตม. ภูเก็ต (Phuket Immigration)", "ขนส่งจังหวัดภูเก็ต",
  "สำนักงานที่ดินจังหวัดภูเก็ต", "แรงงานจังหวัดภูเก็ต", "ศาลจังหวัดภูเก็ต",
];